<template>
  <div class="w-full flex p-6">
    <div class="w-full flex flex-col mx-auto mt-6" style="max-width: 864px">
      <!-- View Title -->
      <div class="flex flex-col gap-1">
        <BaseText type="label" size="md" class="text-text-muted">
          Preferences
        </BaseText>
        <BaseText type="body" size="sm" class="text-text-normal">
          How Foreplay looks and behaves for you.
        </BaseText>
      </div>
      <!-- Divider -->
      <div class="w-full h-px my-5 bg-neutral-50" />
      <div class="flex flex-col lg:flex-row items-start gap-3">
        <!-- Left Column -->
        <div class="w-full lg:flex-1 min-w-0 flex flex-col gap-3">
          <!-- Private Mode -->
          <div class="flex items-start gap-11 p-4 rounded-xl border border-border-normal">
            <div class="flex-1 min-w-0 flex flex-col gap-1">
              <BaseText type="label" size="sm" class="text-text-muted">
                Private Mode
              </BaseText>
              <BaseText type="body" size="sm" class="text-text-normal">
                Hide sensitive details on screen, for demos and screen shares.
              </BaseText>
            </div>
            <BaseToggle medium :value="getIsPrivateMode" color="primary-green-100" class="mt-0.5"
            @toggle="setPrivateMode(!getIsPrivateMode)" />
          </div>
          <!-- Unique Creatives -->
          <div class="flex items-start gap-11 p-4 rounded-xl border border-border-normal">
            <div class="flex-1 min-w-0 flex flex-col gap-1">
              <BaseText type="label" size="sm" class="text-text-muted">
                Unique Creatives
              </BaseText>
              <BaseText type="body" size="sm" class="text-text-normal">
                Group Meta ads that use the same creative into one card.
              </BaseText>
            </div>
            <BaseToggle medium :value="getUniqueCreatives" color="primary-green-100" class="mt-0.5"
            @toggle="setUniqueCreatives(!getUniqueCreatives)" />
          </div>
          <!-- Brand Open View -->
          <div class="flex flex-col gap-3 p-4 rounded-xl border border-border-normal">
            <div class="flex flex-col gap-1">
              <BaseText type="label" size="sm" class="text-text-muted">
                Default Brand Open View
              </BaseText>
              <BaseText type="body" size="sm" class="text-text-normal">
                Pick which page opens when you click a brand.
              </BaseText>
            </div>
            <div class="flex flex-col gap-2" role="radiogroup">
              <button v-for="option in brandOpenViewOptions" :key="`brand-open-view-${option.value}`"
              class="flex items-center gap-2 text-left" role="radio" :aria-checked="String(getBrandOpenView === option.value)"
              @click="setBrandOpenView(option.value)">
                <div class="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <div class="radio-button" :class="{'selected': getBrandOpenView === option.value}">
                    <div class="radio-button-inner" />
                  </div>
                </div>
                <component :is="option.icon" class="text-icon-normal flex-shrink-0" />
                <div class="flex items-center gap-2 min-w-0">
                  <BaseText type="label" size="sm" class="text-text-muted whitespace-nowrap">
                    {{ option.name }}
                  </BaseText>
                  <BaseText type="body" size="xs" class="text-text-normal truncate">
                    {{ option.description }}
                  </BaseText>
                </div>
              </button>
            </div>
          </div>
        </div>
        <!-- Right Column -->
        <div class="w-full lg:flex-1 min-w-0 flex flex-col gap-3">
          <!-- Ad Card Details -->
          <div class="flex flex-col gap-5 p-4 rounded-xl border border-border-normal">
            <div class="flex flex-col gap-1" style="padding-right: 80px">
              <BaseText type="label" size="sm" class="text-text-muted">
                Ad Card Details
              </BaseText>
              <BaseText type="body" size="sm" class="text-text-normal">
                Toggle what information is shown on ad cards in Discovery, Swipe File, and Spyder.
              </BaseText>
            </div>
            <div class="flex flex-col gap-3">
              <div v-for="setting in adCardDetails" :key="`ad-card-detail-${setting}`"
              class="h-6 flex items-center justify-between gap-11">
                <BaseText type="label" size="sm" class="text-text-muted">
                  {{ setting }}
                </BaseText>
                <BaseToggle medium :value="getAdSettings.some(s => s.value === setting)" color="primary-green-100"
                @toggle="toggleAdSetting(setting)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SpyderOverviewIcon from '../globals/Icons/SpyderViewIcons/SpyderOverviewIcon.vue'
import SpyderMetaIcon from '../globals/Icons/SpyderViewIcons/SpyderMetaIcon.vue'

export default {
  name: 'PreferencesSettings',
  data () {
    return {
      brandOpenViewOptions: [
        { value: 'overview', name: 'Overview', description: 'Top ads and trends', icon: SpyderOverviewIcon },
        { value: 'meta', name: 'Meta', description: 'Straight to the ads', icon: SpyderMetaIcon }
      ],
      adCardDetails: ['Brand Details', 'Ad Copy', 'Headline & CTA']
    }
  },
  computed: {
    ...mapGetters('MiscModule', ['getIsPrivateMode', 'getUniqueCreatives', 'getBrandOpenView', 'getAdSettings'])
  },
  methods: {
    ...mapActions('MiscModule', ['setPrivateMode', 'setUniqueCreatives', 'setBrandOpenView', 'toggleAdSetting'])
  }
}
</script>

<style scoped>
.radio-button {
  position: relative;
  width: 14px;
  height: 14px;
  border-radius: 9999px;
  box-shadow: 0px 1px 2px 0px rgba(9, 25, 72, 0.13), 0px 0px 0px 1px rgba(9, 25, 72, 0.13);
  background-color: white;
  transition: box-shadow 150ms ease-in-out, background-color 150ms ease-in-out;
}
.radio-button.selected {
  box-shadow: 0px 0px 0px 1px #1F69FF; /* primary-blue-100 */
  background-color: #1F69FF;
}
.radio-button-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background-color: white;
  box-shadow: 0px 1px 2px 0px rgba(9, 59, 174, 0.60);
  opacity: 0;
  transition: opacity 150ms ease-in-out;
}
.radio-button.selected .radio-button-inner {
  opacity: 1;
}
</style>
